import { useContext, useMemo } from "react";
import { Context } from "@xt/xtbase";
import {
  normalizeUserTags,
  resolveUserTagFeatureState,
} from "@/utils/userTagGrayRelease";

const { XtContext } = Context;

/**
 * 用户标签灰度：标签在 allTags 且用户无该标签 → 不可见；标签不在 allTags → 全量开放。
 * @param {string|undefined|null} featureTag
 * @returns {{ enabled: boolean, ready: boolean }}
 */
export default function useUserTagFeatureEnabled(featureTag) {
  const [appState] = useContext(XtContext);
  const { publicUserTags, publicUserTagsLoaded, userInfo, loginStatus } = appState || {};

  return useMemo(() => {
    if (!featureTag) {
      return { enabled: true, ready: true };
    }

    return resolveUserTagFeatureState({
      featureTag,
      allTags: publicUserTags || [],
      userTags: normalizeUserTags(userInfo),
      tagsLoaded: !!publicUserTagsLoaded,
      loginStatus: loginStatus ?? 0,
    });
  }, [featureTag, publicUserTags, publicUserTagsLoaded, userInfo, loginStatus]);
}
